var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m14 11.523.475-3.142h-2.983V6.34c0-.859.416-1.7 1.75-1.7H14.6V1.965s-1.233-.209-2.408-.209c-2.459 0-4.067 1.509-4.067 4.234V8.38H5.392v3.142h2.733v7.6c.55.083 1.108.133 1.683.133s1.134-.041 1.684-.133v-7.6H14Z",
    fill: "current"
  })));
};
export default SvgFacebook;